// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgDotIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <circle cx={12} cy={12} r={7.5} />
  </g>
);
export default SvgDotIcon;
SvgDotIcon.displayName = 'SvgDotIcon';
